import { FOCUSABLE_ELEMENT_SELECTOR } from "../../../constants/constants";

// iOS Safari sometimes requires a delay before scrolling to ensure the DOM is fully updated and the scroll position is correct.
const IOS_SCROLL_TIMEOUT = 300;

export const scrollToAssumptionGroup = (assumptionGroup: number): void => {
  // Return early if running in server context
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return;
  }

  // Check if iOS device (includes iPhone, iPad, iPod)
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !Object.prototype.hasOwnProperty.call(window, "MSStream");

  const nextAssumptionGroup = document.getElementById(
    `assumption-group-${assumptionGroup}`,
  );

  const firstFocusable = nextAssumptionGroup?.querySelector(
    FOCUSABLE_ELEMENT_SELECTOR,
  ) as HTMLElement;

  if (firstFocusable) {
    firstFocusable?.focus();
  }

  if (nextAssumptionGroup && isIOS) {
    const elementPosition = nextAssumptionGroup.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 20; // Adding some offset

    setTimeout(() => {
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }, IOS_SCROLL_TIMEOUT);
  } else if (nextAssumptionGroup) {
    nextAssumptionGroup.scrollIntoView({ behavior: "smooth" });
  } else {
    // TODO: Probably a good place for Airbake if button can't be found
    const submission = document.getElementById("mobius-submit-action");
    submission?.scrollIntoView({ behavior: "smooth" });
  }
};
